module.exports = __webpack_public_path__ + "static/media/about_04.622f5a6d.png";